import React, {Component} from 'react';

class AnimatedSuccess extends Component {

    render() {
        return (
            <div className="mx-auto" style={{height:112,width:123.2}}>
            <div className="success-checkmark">
                <div className="check-icon">
                    <span className="icon-line line-tip"/>
                    <span className="icon-line line-long"/>
                    <div className="icon-circle"/>
                    <div className="icon-fix"/>
                </div>
            </div>
            </div>
        )
    }
}
export default AnimatedSuccess